export class OrderStatus {
  static expired = "expired";
  static pending = "pending";
  static complete = "complete";
}
